import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { Sort } from '../../rl-common/shared/shared/types/sort';
import { Tag } from '../../store/model/tag.model';

@Pipe({
  name: 'sortTags'
})
export class SortTagsPipe implements PipeTransform {

  constructor(private utilsService : UtilsService) {

  }

  transform(tags : Tag[]): Tag[] {
    const sortBy : Sort[]= [];
    sortBy.push({ field: 'tagTypeFromEntity', dir: 'desc' });
    sortBy.push({ field: 'tagText', dir: 'asc' });
    return this.utilsService.sortComplex(tags, sortBy);
  }

}
